module.exports = __webpack_public_path__ + "static/media/blue-thumb-up.f9e097dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/blue-thumb-up.svg
// module id = 3230
// module chunks = 0